/**
 * 根据系统配置更新页签图标（与 public/index.html 默认 logo.ico 对应）
 * @param {string|null|undefined} companyLogo 接口返回的图标地址，空则回退到 BASE_URL/logo.ico
 */
export function setFaviconFromCompanyLogo(companyLogo) {
  const trimmed = companyLogo && String(companyLogo).trim();
  const href = trimmed || `${process.env.BASE_URL}logo.ico`;

  let link = document.querySelector("link[rel='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = href;
}
